const lang = {
   
    state: {
        language: 'zh_tc'
    },
    mutations:{
        setLanguage(state, lang){
          state.language = lang
        }
    },
    actions:{
        setLanguage(context,lang){
            context.commit('setLanguage', lang)
        }
    }

}

export default lang